<template>
    <div :class="$style.block">
        <div v-show="!setting">
            <span v-text="`${defaultValue}${unit}`"></span><i class="el-icon-edit-outline"
                                                              @click.stop="setting = true"></i>
        </div>
        <div v-show="setting" @click.stop="">
            <el-input
                    :style="{width: width}"
                    :size="size"
                    :max="max"
                    :type="type"
                    :placeholder="placeholder"
                    v-model="value">
                <template v-if="!!unit" slot="suffix">{{unit}}</template>
            </el-input>
            <i :class="[$style.icon,'el-icon-circle-check']" @click="updateFunc"></i>
            <i :class="[$style.icon,'el-icon-circle-close']" @click="closeFunc"></i>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            defaultValue: [String, Number],
            unit: {
                type: String,
                default: ''
            },
            width: {
                type: String,
                default: '70px'
            },
            size: {
                type: String,
                default: '',
            },
            type: {
                type: String,
                default: ''
            },
            max: {
                type: [String, Number],
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                setting: false,
                value: this.defaultValue
            }
        },
        watch: {
            defaultValue(newVal) {
                this.value = newVal
            }
        },
        methods: {
            updateFunc() {
                if (this.max) {
                    if (this.value > this.max) {
                        this.$message.error(`最大值为${this.max}${this.unit}`);
                        return
                    }
                }
                this.$emit('my-submit', {
                    value: this.value,
                    cb: () => {
                        this.setting = false
                    }
                });
            },
            closeFunc() {
                this.setting = false;
            }
        }
    }
</script>
<style lang="scss" module>
    .block {
        display: inline-block;

        :global(.el-input__inner) {
            padding: 0 10px;
        }
        :global(.el-icon-edit-outline) {
            color: $theme-color;
            cursor: pointer;
        }
        :global(.el-input--suffix .el-input__inner) {
            padding-right: 20px;
        }
        :global(.el-input__suffix) {
            display: flex;
            align-items: center;
        }
        .icon {
            margin-left: 3px;
            font-size: 20px;
            vertical-align: middle;
            cursor: pointer;
            &:hover {
                color: $theme-color;
                transform: translateY(-1px);
            }
        }
    }

    :global(.el-icon-edit-outline) {
        color: $theme-color;
        cursor: pointer;
    }
</style>